module.exports = __webpack_public_path__ + "static/media/8OLA28.aa71d328.jpg";